if(typeof BSS_B2B != undefined) {
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  const debouncedHandlePrice = debounce(() => {
    BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
      BSS_B2B.observer.cartSubject.listenCartCheckout();
    BSS_B2B.nt.initFunction()
    document.dispatchEvent(new Event("DOMContentLoaded"))
  }, 200);
  
  //fix change variant
  function setupMainProduct() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) return;

    const mainObserver = new MutationObserver((mutations) => {
        debouncedHandlePrice()
    })

    mainObserver.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ["class"],
    });
  }
  
  setTimeout(setupMainProduct, 2000);
  
}

const cartPage = document.querySelector("#CartPage");
if(cartPage){
  cartPage.addEventListener('change', () =>{
    window.dispatchEvent(new Event('bss_b2b:CustomInitCartSubject'));
  })
}